import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import SuccessIcon from '@material-ui/icons/Done';
import CopyTextField from '../CopyTextField';
import './DownloadLicenseDialog.scss';

const DownloadLicenseDialogHOC = ({ getSecret = key => key.secret, getKey = key => key.key }) => {
  const DownloadLicenseDialog = ({ open, onClose, apiKey, apiKeyService, ...rest }) => {
    const [blobURL, setBlobURL] = useState(null);
    const handleClose = () => onClose();

    useEffect(() => {
      if (blobURL) {
        apiKeyService.revokeLicenseDownloadURL(blobURL);
      }
      async function fetchDownloadURL() {
        setBlobURL(await apiKeyService.fetchLicenseDownloadURL(apiKey, rest));
      }

      fetchDownloadURL();
      return () => {
        if (blobURL) {
          apiKeyService.revokeLicenseDownloadURL(blobURL);
        }
      };
    }, [apiKey, apiKeyService]);

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        aria-labelledby="download-license-dialog-title"
        id="download-license-dialog-ctnr"
        open={open}
      >
        <DialogContent className="grb-download-license-dialog">
          <DialogContentText className="grb-download-license-dialog-message" id="download-license-dialog-title">
            <SuccessIcon />API Key created
          </DialogContentText>
          <CopyTextField
            autoFocus
            value={getKey(apiKey)}
            id="apiKey"
            label="API Key"
            fullWidth
          />
          {/* For e2e tests to get hold on the secret */}
          <div style={{ display: 'none' }} id="KeySecretForTest" className={getSecret(apiKey)} />
          <Typography variant="body2">
            For security reasons, this is the only time you can download this new license file which contains your private API access ID and secret.
            However, you can create new API access keys at any time.
          </Typography>
        </DialogContent>
        <DialogActions>
          {!!blobURL && (
            <Tooltip title="Download license file">
              <a href={blobURL} download="gurobi.lic" aria-label="download" onClick={handleClose} id="download-api-key-button">
                <Button>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" /></svg>
                  Download
                </Button>
              </a>
            </Tooltip>
          )}
          {!blobURL && (
            <Tooltip title="Close dialog">
              <Button onClick={handleClose}>
                Close
              </Button>
            </Tooltip>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  DownloadLicenseDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    apiKey: PropTypes.shape({
      key: PropTypes.string,
      secret: PropTypes.string,
    }).isRequired,
    open: PropTypes.bool.isRequired,
    apiKeyService: PropTypes.shape({
      fetchLicenseDownloadURL: PropTypes.func,
      revokeLicenseDownloadURL: PropTypes.func,
    }).isRequired,
  };

  return DownloadLicenseDialog;
};

export default DownloadLicenseDialogHOC;
